module.exports = __webpack_public_path__ + "img/hx-kshjk-w.9f89f764.svg";